import { plural, t } from "@lingui/macro";
import React from "react";
import InformationPill from "~/applications/OfferSearch/Ui/OfferDetails/InformationPill";
import { Bed } from "~/guidelines/Icon";
import ListItemWithIcon from "~/guidelines/ListItemWithIcon";

export type RoomTypologyAmenityProps = {
  variant?: "list-item" | "pill";
  nbRoom: number;
  hasLivingRoom: boolean;
};

const RoomTypologyAmenity = ({
  variant = "list-item",
  nbRoom,
  hasLivingRoom,
}: RoomTypologyAmenityProps) => {
  if (variant === "pill") {
    return (
      <InformationPill
        icon={<Bed />}
        text={
          plural(nbRoom, {
            one: `${nbRoom} room`,
            other: `${nbRoom} rooms`,
          }) + (hasLivingRoom ? t` + living room` : "")
        }
      />
    );
  }

  return (
    <ListItemWithIcon icon={<Bed />}>
      {plural(nbRoom, { one: `${nbRoom} room`, other: `${nbRoom} rooms` }) +
        (hasLivingRoom ? t` + living room` : "")}
    </ListItemWithIcon>
  );
};

export default RoomTypologyAmenity;
